module.exports = __webpack_public_path__ + "img/burger-ex-2.54806b6a.svg";